import {load} from "@shopify/theme-sections";
import smoothscroll from "smoothscroll-polyfill";
import ProductSlider from "../sections/product-slider";
import Recommendations from "../sections/recommendations-collection";
import RecentlyViewed from "../components/recently-viewed";
import TestimonialSlider from "../snippets/article-slider";
import Testimonial from "../sections/testimonials-two";
import SwatchProduct from "../sections/swatch";
import AccordionReadmore from "../components/accordion-read-more";
import Ingredients from "../components/ingredients-hide-show";
import Readmore from "../sections/product-readmore";
import katiesStory from "../sections/katies-story";
import backToTop from "../sections/product-back-to-top";
import RealWomen from "../sections/product-real-women";
import "../sections/product";

const validator = require("email-validator");
const mailcheck = require("mailcheck");

if (document.body.classList.contains("template-product")) {

  RecentlyViewed().init();
  TestimonialSlider().init();
  Testimonial().init();

  SwatchProduct({
    container: '[js-swatch-product="main"]',
    updateSlider: false,
  }).init();

  katiesStory().init();
  Readmore().init();

  backToTop().init();
  RealWomen().init();
  ProductSlider().init();

  if (document.querySelector(".accordion") !== null) {
    AccordionReadmore().init();
  }

  const ingredients = document.getElementById("ingredients-hideShow");
  if (typeof ingredients !== "undefined" && ingredients != null) {
    Ingredients();
  }

  smoothscroll.polyfill();

  setTimeout(() => {
    Recommendations().init();
  }, 1000);

  class BackInStock extends HTMLElement {
    constructor() {
      super();

      this.addEventListener("click", () => {
        const _form = this.nextElementSibling;
        _form.classList.remove("visually-hidden");
      });
    }
  }

  customElements.define("back-in-stock", BackInStock);
// bump
  class NotifyMeWrapper extends HTMLElement {
    constructor() {
      super();
      const _email = this.querySelector("#email_bis");
      const _id = this.querySelector("#product-id_bis");
      const _emailConfirmation = this.querySelector("#fieldEmailConfirmation");
      const shouldSignup = this.querySelector("#email-for-signup");

      // add domains to exlucde
      const domains = [
        "gmail.com",
        "outlook.com",
        "hotmail.com",
        "hotmail.co.uk",
        "hotmail.fr",
        "msn.com",
        "aol.com",
        "icloud.com",
        "talktalk.com",
        "yahoo.com",
        "proton.com",
        "proton.me",
        "sky.com",
        "doctors.org.uk",
        "doctors.org",
        "doctors.uk",
        "me.com",
      ];
      const secondLevelDomains = ["hotmail"];
      const topLevelDomains = [
        "com",
        "net",
        "org",
        "uk",
        "gov",
        "ac",
        "co.uk",
        "ac.uk",
        "sch.uk",
        "doctors",
        "me",
      ];

      this.querySelector("form").addEventListener("submit", (e) => {
        e.preventDefault();

        const isEmailValid = validator.validate(_email.value);

        const isEmailCorrect = mailcheck.run({
          domains,
          topLevelDomains,
          email: _email.value,
          suggested: (res) => {
            return res;
          },
        });

        if (isEmailValid) {
          if (isEmailCorrect?.full) {
            _emailConfirmation.classList.remove("visually-hidden");
            if (_emailConfirmation.value !== "") {
              this.checkEmailsMatch(_id);
            }
          } else {
            this.subscribeCustomer(_email.value, _id.value, this);
            if (shouldSignup.checked) {
              this.subscribeCustomerToMailList(_email.value, _id.value);
            }
          }
        } else {
          _emailConfirmation.classList.remove("visually-hidden");
          if (_emailConfirmation.value !== "") {
            this.checkEmailsMatch(_id);
          }
        }
      });
    }

    static get observedAttributes() {
      return ["data-sent"];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      const d = this.getAttribute("data-sent");
      if (name === "data-sent") {
        this.resetForm();
      }
    }

    checkEmailsMatch(id) {
      const _email = this.querySelector("#email_bis");
      const _emailConfirmation = this.querySelector("#fieldEmailConfirmation");
      const shouldSignup = this.querySelector("#email-for-signup");

      if (_email.value !== _emailConfirmation.value) {
        this.querySelector("#emails-do-not-match").classList.remove(
          "visually-hidden",
        );

        setTimeout(() => {
          this.querySelector("#emails-do-not-match").classList.add(
            "visually-hidden",
          );
        }, 4500);
      } else {
        this.subscribeCustomer(_email.value, id.value, this);

        if (shouldSignup.checked) {
          this.subscribeCustomerToMailList(_email.value, id.value);
        }
      }
    }

    resetForm() {
      this.querySelectorAll(".pre-submit").forEach((el) => {
        el.classList.add("visually-hidden");
      });
      this.querySelector("p").classList.remove("visually-hidden");
      this.querySelector("#email_bis").value = "";
      this.querySelector("#fieldEmailConfirmation").value = "";
      this.querySelector("#fieldEmailConfirmation").classList.add(
        "visually-hidden",
      );

      setTimeout(() => {
        this.querySelectorAll(".pre-submit").forEach((el) => {
          // eslint-disable-next-line no-empty
          if (el.id === "valid-error") {
          } else {
            el.classList.remove("visually-hidden");
          }
        });
        this.querySelector("p").classList.add("visually-hidden");
      }, 4000);
    }

    async subscribeCustomer(_e, _id, _parent) {
      try {
        const url =
          "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Um6rUb";

        const options = {
          method: "POST",
          headers: {
            accept: "application/json",
            revision: "2024-02-15",
            "content-type": "application/json",
          },
          body: JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                channels: ["EMAIL"],
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: `${_e.trim()}`,
                    },
                  },
                  email: `${_e.trim()}`,
                },
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: `$shopify:::$default:::${_id.trim()}`,
                  },
                },
              },
            },
          }),
        };

        const request = await fetch(url, options);
        _parent.setAttribute("data-sent", true);
        return request;
      } catch (err) {
        console.error(
          "uh oh! There was an error adding customer to the wait list: ",
          err,
        );
      }
    }

    async subscribeCustomerToMailList(_e, _id) {
      try {
        const url =
          "https://a.klaviyo.com/client/subscriptions/?company_id=Um6rUb";

        const options = {
          method: "POST",
          headers: {revision: "2024-02-15", "content-type": "application/json"},
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                custom_source: `Beauty Secrets Sign Up - via API (Optional signup on BIS for ${_id})`,
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: `${_e}`,
                      properties: {emailValidated: true},
                    },
                  },
                },
              },

              relationships: {list: {data: {type: "list", id: "U8ADFN"}}},
            },
          }),
        };

        const request = await fetch(url, options);
        return request;
      } catch (err) {
        console.error(
          "uh oh! There was an error adding customer to the wait list: ",
          err,
        );
      }
    }
  }

  customElements.define("notify-me-wrapper", NotifyMeWrapper);

  if (document.querySelector(".bis-closer")) {
    document
      .querySelector(".bis-closer")
      .addEventListener("click", function () {
        this.closest(".bis-modal").classList.add("visually-hidden");
      });
  }

  load("*");
}
